import { render, staticRenderFns } from "./licenseRequest.vue?vue&type=template&id=8745d4d2&"
import script from "./licenseRequest.vue?vue&type=script&lang=js&"
export * from "./licenseRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports